import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { API } from 'aws-amplify';
import { HelperService } from 'src/app/shared/services/helper_service';
import { TranslateService } from '@ngx-translate/core';
import { PopoverController } from "@ionic/angular";
import { PayablebalacePopoverPage } from '../payablebalace-popover/payablebalace-popover.page';
@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.page.html',
  styleUrls: ['./confirmation.page.scss'],
})
export class ConfirmationPage implements OnInit, OnDestroy, OnChanges {
  @Input() entryAmount: any
  @Input() matchId: any
  @Input() contestId: any;
  @Input() matchDetails: any;
  @Input() teamName: any;
  @Input() routerLink: string;
  @Input() cashType: number;
  @Input() selectedTeams = [];
  @Input() bonusallowed : any
  @Input()sharecode;
  allTeamData: any;
  team: any;
  lineUpId: any;
  display: boolean = false;
  realAmount: any;
  bonusAmount: any;
  coinsAmount: any;
  isJoinContest: boolean ;
  joined_response : boolean ;
  clicked;
  winningsAmount;
  disablebutton : boolean ;
  language: string;


  constructor(
    private modal: ModalController,
    private router: Router,
    private helperService: HelperService,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private popoverCtrl: PopoverController
  ) {
    this.getUserWalletBalance();
  }
  ionViewWillEnter() {
    console.log("run on ionic oninit");
    this.language = localStorage.getItem("language");
    if (this.language === 'hn') {
      this.translate.use('hn');
    }
    else if (this.language === 'en') {
      this.translate.use('en');
    }
    else if (this.language === 'kn') {
      this.translate.use('kn');
    }
  }

  ngOnInit() { 
    this.cdRef.detectChanges();
    console.log(this.matchDetails);
    this.matchId = this.matchDetails.matchId ;
    console.log("Bonusallowed",this.bonusallowed);
    
    console.log("teamNm : ", this.team);
    console.log("teamName : ", this.teamName);
    this.getData();
    //this.checkBalance();
    console.log(this.cashType);
  }
    async showPopover(event) {
    const popover = await this.popoverCtrl.create({
      component: PayablebalacePopoverPage,
      event,
      componentProps: { bonusallowed: this.bonusallowed,}
    });
    await popover.present();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("selected teams at confirma", this.selectedTeams);
    console.log(changes)
  }

  checkBalance() {
    if(!this.selectedTeams){
      // console.log("Hhi");
      if (this.cashType == 0 && this.entryAmount < this.bonusAmount) {
        console.log("insufficient bonusAmount", this.bonusAmount);
        this.isJoinContest = false;
      } else if (this.cashType == 1 && this.entryAmount  < this.realAmount) {
        console.log("insufficient realAmount", this.realAmount);
        this.isJoinContest = false;
      } else if (this.cashType == 2 && this.entryAmount < this.coinsAmount) {
        console.log("insufficient coinsAmount", this.coinsAmount);
        this.isJoinContest = false;
      } else {
        this.isJoinContest = true;
        console.log("old loop");
        
      }
    }else{
      console.log(this.selectedTeams.length);
      if (this.cashType == 0 && this.entryAmount * this.selectedTeams.length < this.bonusAmount) {
        console.log(this.entryAmount * this.selectedTeams.length);
        console.log("insufficient bonusAmount", this.bonusAmount);
        this.isJoinContest = false;
      } else if (this.cashType == 1 && this.entryAmount * this.selectedTeams.length < this.realAmount) {
        console.log(this.entryAmount * this.selectedTeams.length);
        console.log("insufficient realAmount", this.realAmount);
        this.isJoinContest = false;
      } else if (this.cashType == 2 && this.entryAmount * this.selectedTeams.length < this.coinsAmount) {
        console.log(this.entryAmount * this.selectedTeams.length);
        console.log("insufficient coinsAmount", this.coinsAmount);
        this.isJoinContest = false;
      } else {
        this.isJoinContest = true;
        console.log("old loop");
        
      }
    }

  }

  getUserWalletBalance() {
    const apiName = 'walletApi';
    const path = '/wallet/balance';
    const myInit = {
      headers: {},
      response: true,
    };
    API.get(apiName, path, myInit)
      .then(response => {
        console.log(response.data?.data);
        this.disablebutton = response.data?.success ;
        console.log("success",this.disablebutton);
        
        this.bonusAmount = response.data?.data?.bonusAmount;
        this.coinsAmount = response.data?.data?.coinsAmount;
        this.realAmount = response.data?.data?.realAmount;
        this.winningsAmount = response.data?.data?.winningsAmount
        console.log(this.bonusAmount);
        
        if(this.selectedTeams){
          if (this.cashType == 0 && (this.entryAmount * this.selectedTeams.length) <= this.bonusAmount) {
            console.log("insufficient bonusAmount", this.bonusAmount);
            this.isJoinContest = true;
          } else if(this.cashType == 0 && (this.entryAmount * this.selectedTeams.length) >= this.bonusAmount){
            console.log("insufficient bonusAmount", this.bonusAmount);
            this.isJoinContest = false;
            console.log("bonusbalance",this.isJoinContest);
          }
          else if ((this.cashType == 1 && this.bonusallowed > 0) && this.bonusAmount <= 0 && (this.entryAmount * this.selectedTeams.length) <= (this.realAmount + this.winningsAmount)) {
            console.log("Bonus percentage",(((this.bonusallowed / 100) * this.entryAmount) <= this.bonusAmount));
            this.isJoinContest = true;
            console.log("JoinContest boolean",this.isJoinContest);
          }
          else if ((this.cashType == 1 && this.bonusallowed > 0) && this.bonusAmount <= 0 && (this.entryAmount * this.selectedTeams.length) >= (this.realAmount + this.winningsAmount)) {
             console.log("Bonus percentage",(((this.bonusallowed / 100) * this.entryAmount) <= this.bonusAmount));
            this.isJoinContest = false;
            console.log("JoinContest boolean",this.isJoinContest);
          }
            else if ((this.cashType == 1 && this.bonusallowed > 0) && this.bonusAmount > 0 && (this.entryAmount * this.selectedTeams.length) <= (this.realAmount + this.winningsAmount + ((this.bonusallowed / 100) * this.entryAmount))) {
              console.log("Bonus percentage",(((this.bonusallowed / 100) * this.entryAmount) <= this.bonusAmount));
              this.isJoinContest = true;
              console.log("JoinContest boolean",this.isJoinContest);
            }
            else if ((this.cashType == 1 && this.bonusallowed > 0) && this.bonusAmount > 0 && (this.entryAmount * this.selectedTeams.length) >= (this.realAmount + this.winningsAmount + ((this.bonusallowed / 100) * this.entryAmount))) {
               console.log("Bonus percentage",(((this.bonusallowed / 100) * this.entryAmount) <= this.bonusAmount));
              this.isJoinContest = false;
              console.log("JoinContest boolean",this.isJoinContest);
            }
          
          else if (this.cashType == 1 && (this.entryAmount * this.selectedTeams.length) <= (this.realAmount + this.winningsAmount)) {
            console.log("insufficient realAmount", this.realAmount);
            this.isJoinContest = true;
          }else if (this.cashType == 1 && (this.entryAmount * this.selectedTeams.length) >= (this.realAmount + this.winningsAmount)){
            console.log("insufficient realAmount", this.realAmount);
            this.isJoinContest = false;
            console.log("realbalance",this.isJoinContest);
          }else if (this.cashType == 2 && (this.entryAmount * this.selectedTeams.length) <= this.coinsAmount) {
            console.log("insufficient coinsAmount", this.coinsAmount);
            this.isJoinContest = true;
            console.log( "coins balance",this.isJoinContest);
          }else if (this.cashType == 2 && (this.entryAmount * this.selectedTeams.length) >= this.coinsAmount){
            console.log("insufficient coinsAmount", this.coinsAmount);
            this.isJoinContest = false;
            console.log( "coins balance",this.isJoinContest);
          }
        }else{
          if (this.cashType == 0 && this.entryAmount <= this.bonusAmount) {
            console.log("insufficient bonusAmount", this.bonusAmount);
            this.isJoinContest = true;
          }
          else if ((this.cashType == 1 && this.bonusallowed > 0) && this.bonusAmount > 0 && (this.entryAmount) <= (this.realAmount + this.winningsAmount + ((this.bonusallowed / 100) * this.entryAmount))) {
            console.log("Bonus percentage with single join",((this.bonusallowed / 100) * this.entryAmount));
            this.isJoinContest = true;
            console.log("JoinContest boolean",this.isJoinContest);
          }
           else if (this.cashType == 1 && this.entryAmount <= (this.realAmount + this.winningsAmount)) {
            console.log("insufficient realAmount", (this.realAmount + this.winningsAmount));
            this.isJoinContest = true;
            console.log("new loop");
            
          } else if (this.cashType == 2 && this.entryAmount <= this.coinsAmount) {
            console.log("insufficient coinsAmount", this.coinsAmount);
            this.isJoinContest = true;
          }
           else {
            this.isJoinContest = false;
            console.log("JoinContest boolean",this.isJoinContest);
          }
        }

      })
      .catch(error => {
        console.log(error);
      });
  }
  onSelectTeam(team){
    console.log(team);
    this.clicked = false;
  }

  joinGameWithMalti() {
    if (this.selectedTeams?.length) {
      // for (let team of this.selectedTeams) {
        const apiName = 'fantasyApi';
        const path = '/fantasy/multi-join-game';
        const myInit = {
          headers: {},
          response: true,
          body: {
            "sportId": 1,
            "gameId": 1,
            "matchId": this.matchId,
            "contestId": this.contestId,
            "lineUpIds": this.selectedTeams,
          }
        };
        API.post(apiName, path, myInit)
          .then(response => {
            console.log(response);
            this.helperService.presentToast(response?.data?.message);
            this.modal.dismiss(true);
          })
          .catch(error => {
            this.helperService.presentToast(error?.response?.data?.message);
            //this.modal.dismiss();
          });
      // }
    } else {
      this.joinGame();
    }
  }

  joinGame() {
    if (this.team) {
      for (let team of this.allTeamData) {
        console.log(team.lineUpTitle);
        if (this.team.trim() == team.lineUpTitle.trim()) {
          console.log("if is run");
          this.lineUpId = team.lineUpId;
          console.log("lineUpId", this.lineUpId);
          break;
        }
      }
      const apiName = 'fantasyApi';
      const path = '/fantasy/join-game';
      const myInit = {
        headers: {},
        response: true,
        body: {
          "sportId": 1,
          "gameId": 1,
          "matchId": this.matchId,
          "contestId": this.contestId,
          "lineUpId": this.lineUpId,
        }
      };
      API.post(apiName, path, myInit)
        .then(response => {
          console.log(response);
          this.joined_response = response.data.success ;
          console.log(this.joined_response);
          if(!this.joined_response){
           this.clicked = false;
          }
          
          this.helperService.presentToast(response?.data?.message);
          this.modal.dismiss(true);
        })
        .catch(error => {
          this.helperService.presentToast(error?.response?.data?.message);
          //this.modal.dismiss();
        });
    } else {
      this.clicked = true;
      this.helperService.presentToast("please select Team!");
    }
  }

  goToAddFunds() {
    this.modal.dismiss();
    this.router.navigate(['/mywallet/addfunds'], { queryParams: { 
      routerLink: this.routerLink, matchDetails: JSON.stringify(this.matchDetails),
      contestId:this.contestId,entryAmount: this.entryAmount,teamName: this.teamName,cashTypeconfirm: this.cashType,
      selectedTeams :this.selectedTeams} });
  }

  getData() {
    console.log("COnfirm page matchid",this.matchDetails.matchId);
    
    console.log("matchId", this.matchDetails.matchId);
    const apiName = 'fantasyApi';
    const path = "/fantasy/lineup";
    const myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        sportId: 1,
        gameId: 1,
        matchId: this.matchDetails.matchId
        // lineUpId: "649ca10c0d2a4b4b85ad276a13ba9c6a"
      },
    };
    API.get(apiName, path, myInit)
      .then(data => {
        this.allTeamData = data.data.data;
        console.log("allTeamData at confirmpage", this.allTeamData);
        this.team = this.teamName;
      }).catch((error) => {
        console.log(error);
      });
    // this.team = this.teamName;
  }
  goToCreateteems() {
    this.modal.dismiss();
    this.router.navigate(['createteams'], { queryParams: { matchDetails: JSON.stringify(this.matchDetails),matchId: this.matchDetails.matchId, submitButton: "Submit LineUp", entryAmount: this.entryAmount, contestId: this.contestId, cashType: this.cashType,reset:true,sharecode:this.sharecode } });
  }
  ngOnDestroy() {

  }
}
